import { motion } from 'motion/react';
import React from 'react';

interface AnswerIndicatorProps {
  answer?: boolean;
  onAnimateEnd?: () => void;
}

const variants = {
  start: {
    pathLength: 0,
  },
  finished: {
    pathLength: 1,
    transition: {
      duration: 0.5,
    },
  },
};

const AnswerIndicator = (props: AnswerIndicatorProps) => {
  const { answer } = props;

  if (answer === undefined) {
    return null;
  }

  if (props.answer) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        className="lucide lucide-check stroke-green-500"
        viewBox="0 0 24 24"
      >
        <motion.path
          d="M20 6L9 17l-5-5"
          variants={variants}
          initial="start"
          animate="finished"
          onAnimationComplete={props.onAnimateEnd}
        ></motion.path>
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="lucide lucide-x stroke-red-500"
      viewBox="0 0 24 24"
    >
      <motion.path
        d="M18 6L6 18M6 6l12 12"
        variants={variants}
        initial="start"
        animate="finished"
        onAnimationComplete={props.onAnimateEnd}
      ></motion.path>
    </svg>
  );
};

export default AnswerIndicator;
